<div class="d-md-flex align-items-center bg-white p-3">
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Documenti:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
  </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button type="button" class="btn btn-cyan rounded-pill py-2" *ngIf="permission.isPermitted('gestione-documenti')" (click)="openEditModal(editDocumentModal)"><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
  </div>
</div>

<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
      <tr>
        <th >Descrizione</th>
        <th scope="col">File</th>
        <th scope="col">Old</th>
        <th scope="col">Revisione</th>
        <th scope="col">Caricato il</th>
        <th scope="col" *ngIf="permission.isPermitted('gestione-documenti')">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of Documenti | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td (click)='openEditModal(editDocumentModal, item)'>
          <span class="font-14">{{item.descrizione}}</span>
        </td>
        <td class="align-middle" (click)='openEditModal(editDocumentModal, item)'>
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="file-text" class="feather-sm"></i-feather>
            </span>
            {{ item.file }}
          </span>
        </td>
        <td class="align-middle position-relative" (click)='openEditModal(editDocumentModal, item)'>
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="mdi mdi-bulletin-board"></i>
            </span>
            {{item.old}}
          </span>
        </td>
        <td class="align-middle" (click)='openEditModal(editDocumentModal, item)'>
          <span >
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="user-check" class="feather-sm"></i-feather>
            </span>
            {{ item.revisione }}
          </span>
        </td>
        <td class="align-middle" (click)='openEditModal(editDocumentModal, item)'>
          <span >
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="user-check" class="feather-sm"></i-feather>
            </span>
            {{ item.date | date:'dd/MM/yyyy'}}
          </span>
        </td>
        <td class="align-middle" *ngIf="permission.isPermitted('gestione-documenti')">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
            (click)="openEditModal(editDocumentModal, item)">
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <a href="javascript:void(0)" ngbTooltip="Elimina"
            class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf=" item.allegato !== '' " href="javascript:void(0)" class="link  font-16 font-weight-bold mr-2"
            (click)='download(item)'>
            <i-feather name="download" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>


<ng-template #editDocumentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Documento</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="Selected">
    <app-field-viewer [(Campi)]="campi" [(Oggetto)]="Selected" (OnFilter)="Filter($event)" [(DropdownSources)]="DropdownSources"></app-field-viewer>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
      <button type="submit" (click)="saveModal()"
        class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>

